export const projectData = [
  {
    image:
      "https://res.cloudinary.com/orrin/image/upload/v1738219034/p3_juriiu_qmtfmh.png",
    heading: "Links Vault - Bookmark Organizer",
    desc: "Organize your links from different sources. Access from anywhere. Automatic categorization.",
    link: "https://linksvault.vercel.app",
  },
  {
    image:
      "https://res.cloudinary.com/orrin/image/upload/v1738186438/p4_sxncgp.webp",
    heading: "Store Mate - The Inventory Manager",
    desc: "Effortlessly manage inventory, track sales, and boost your business growth with our product.",
    link: "https://orrinstore.vercel.app",
  },
  {
    image:
      "https://res.cloudinary.com/orrin/image/upload/v1738218852/Screenshot_2025-01-30_120333_jid47b.png",
    heading: "Serum - Product Landing Page",
    desc: "The product of the website is generated from AI, A demo hero section of a product landing page.",
    link: "https://glowserum.vercel.app",
  },
  {
    image:
      "https://res.cloudinary.com/orrin/image/upload/v1738219646/Untitled_s54wwc.png",
    heading: "Email Scraper",
    desc: "Scrape emails from different sources and get a list of emails.",
    link: "https://github.com/subhajitorrin/email-scraper",
  },
];

export const colorArr = [
  "#89f480",
  "#c0b623",
  "#e36211cd",
  "#1cbcb9",
  "#39a82d",
  "#7116d8",
  "#bb1e84",
  "#a21f1f"
];

export const getCurrentColor = (index) => colorArr[index] || colorArr[0];
